/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react';
import { Box, CircularProgress } from '@mui/material'

export default function Loader({btn,creatUser}) {
  return (
    <Box sx={{ display: 'flex',justifyContent: "center",marginTop: `${btn ? "0rem": "2rem"}`}} css={css`.MuiCircularProgress-root{color: rgb(135, 206, 235);}`}><CircularProgress size={btn ? (creatUser? "1.2rem" : "1.6rem") : "3rem"} /></Box>
  )
}
